import React from 'react';
import { ChevronDown } from 'lucide-react';

const ScrollIndicator = () => {
  const scrollToNext = () => {
    const element = document.getElementById('about');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
      <button
        onClick={scrollToNext}
        className="flex flex-col items-center text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors group"
        aria-label="Scroll to next section"
      >
        <span className="text-sm mb-2 opacity-75 group-hover:opacity-100">Scroll Down</span>
        <div className="relative">
          <ChevronDown className="w-8 h-8 animate-bounce" />
          <div className="absolute inset-0 w-8 h-8 bg-blue-400/20 rounded-full animate-ping"></div>
        </div>
      </button>
    </div>
  );
};

export default ScrollIndicator;